webpackJsonp([262],{

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationQuestionnairePreview_vue__ = __webpack_require__(2790);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a67bb9b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationQuestionnairePreview_vue__ = __webpack_require__(4587);
function injectStyle (ssrContext) {
  __webpack_require__(4581)
  __webpack_require__(4583)
  this["$style"] = __webpack_require__(4585)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a67bb9b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationQuestionnairePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a67bb9b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationQuestionnairePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      tablePath: '/users/occupation-questionnaire/table',
      detail: {
        title: '',
        detail: '',
        occupations: []
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('previewOccupationQuestionnaire', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.detail, data);
      });
    }
  })
});

/***/ }),

/***/ 4581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("797276ac", content, true, {});

/***/ }),

/***/ 4582:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OccupationQuestionnairePreview.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4583:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f33be094", content, true, {});

/***/ }),

/***/ 4584:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "/*! Devices.css v0.1.16 | MIT License | github.com/picturepan2/devices.css */.device[data-v-a67bb9b0],.device [data-v-a67bb9b0],.device[data-v-a67bb9b0]:after,.device [data-v-a67bb9b0]:after,.device[data-v-a67bb9b0]:before,.device [data-v-a67bb9b0]:before{-webkit-box-sizing:border-box;box-sizing:border-box;display:block}.device[data-v-a67bb9b0]{position:relative;-webkit-transform:scale(1);transform:scale(1);z-index:1}.device .device-frame[data-v-a67bb9b0]{z-index:1}.device .device-content[data-v-a67bb9b0]{background-color:#fff;background-position:50%;background-size:cover;-o-object-fit:cover;object-fit:cover;position:relative}.device-iphone-x[data-v-a67bb9b0]{height:868px;width:428px}.device-iphone-x .device-frame[data-v-a67bb9b0]{background:#222;border-radius:68px;-webkit-box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;height:868px;padding:28px;width:428px}.device-iphone-x .device-content[data-v-a67bb9b0]{border-radius:40px;height:812px;width:375px}.device-iphone-x .device-stripe[data-v-a67bb9b0]:after,.device-iphone-x .device-stripe[data-v-a67bb9b0]:before{border:solid rgba(51,51,51,.25);border-width:0 7px;content:\"\";height:7px;left:0;position:absolute;width:100%;z-index:9}.device-iphone-x .device-stripe[data-v-a67bb9b0]:after{top:85px}.device-iphone-x .device-stripe[data-v-a67bb9b0]:before{bottom:85px}.device-iphone-x .device-header[data-v-a67bb9b0]{background:#222;border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:30px;left:50%;margin-left:-102px;position:absolute;top:28px;width:204px}.device-iphone-x .device-header[data-v-a67bb9b0]:after,.device-iphone-x .device-header[data-v-a67bb9b0]:before{content:\"\";height:10px;position:absolute;top:0;width:10px}.device-iphone-x .device-header[data-v-a67bb9b0]:after{background:radial-gradient(circle at bottom left,transparent 0,transparent 75%,#222 0,#222 100%);left:-10px}.device-iphone-x .device-header[data-v-a67bb9b0]:before{background:radial-gradient(circle at bottom right,transparent 0,transparent 75%,#222 0,#222 100%);right:-10px}.device-iphone-x .device-sensors[data-v-a67bb9b0]:after,.device-iphone-x .device-sensors[data-v-a67bb9b0]:before{content:\"\";position:absolute}.device-iphone-x .device-sensors[data-v-a67bb9b0]:after{background:#444;border-radius:3px;height:6px;left:50%;margin-left:-25px;top:32px;width:50px}.device-iphone-x .device-sensors[data-v-a67bb9b0]:before{background:#444;border-radius:50%;height:14px;left:50%;margin-left:40px;top:28px;width:14px}.device-iphone-x .device-btns[data-v-a67bb9b0]{background:#c8cacb;height:32px;left:-3px;position:absolute;top:115px;width:3px}.device-iphone-x .device-btns[data-v-a67bb9b0]:after,.device-iphone-x .device-btns[data-v-a67bb9b0]:before{background:#c8cacb;content:\"\";height:62px;left:0;position:absolute;width:3px}.device-iphone-x .device-btns[data-v-a67bb9b0]:after{top:60px}.device-iphone-x .device-btns[data-v-a67bb9b0]:before{top:140px}.device-iphone-x .device-power[data-v-a67bb9b0]{background:#c8cacb;height:100px;right:-3px;position:absolute;top:200px;width:3px}.device .mobile-container[data-v-a67bb9b0]{padding:20px;border-radius:40px;background-color:#fff;height:100%;cursor:all-scroll;overflow:scroll}.device .mobile-container h1[data-v-a67bb9b0]{margin-top:100px}.device .mobile-container .occupations-list[data-v-a67bb9b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:left;-ms-flex-align:left;align-items:left;-ms-flex-wrap:wrap;flex-wrap:wrap}.device .mobile-container .occupations-list .occupations-list-item[data-v-a67bb9b0]{width:100px;padding:10px;text-align:center}.device .occupations-submit[data-v-a67bb9b0]{background:#d4a146;color:#fff;width:100%;text-align:center;position:relative;bottom:35px;height:35px;line-height:35px;border-radius:0 0 40px 40px}", "", {"version":3,"sources":["/workspace/src/views/occupation-questionnaire/pages/OccupationQuestionnairePreview.vue"],"names":[],"mappings":"AAAA,6EAA6E,AAC7E,mLAA0L,8BAA8B,sBAAsB,aAAa,CAC1P,AACD,yBAAyB,kBAAkB,2BAA2B,mBAAmB,SAAS,CACjG,AACD,uCAAuC,SAAS,CAC/C,AACD,yCAAyC,sBAAsB,wBAAkC,sBAAsB,oBAAoB,iBAAiB,iBAAiB,CAC5K,AACD,kCAAkC,aAAa,WAAW,CACzD,AACD,gDAAgD,gBAAgB,mBAAmB,qEAAqE,6DAA6D,aAAa,aAAa,WAAW,CACzP,AACD,kDAAkD,mBAAmB,aAAa,WAAW,CAC5F,AACD,+GAAiH,gCAAiC,mBAAmB,WAAW,WAAW,OAAO,kBAAkB,WAAW,SAAS,CACvO,AACD,uDAAwD,QAAQ,CAC/D,AACD,wDAAyD,WAAW,CACnE,AACD,iDAAiD,gBAAgB,+BAA+B,gCAAgC,YAAY,SAAS,mBAAmB,kBAAkB,SAAS,WAAW,CAC7M,AACD,+GAAiH,WAAW,YAAY,kBAAkB,MAAM,UAAU,CACzK,AACD,uDAAwD,iGAAuG,UAAU,CACxK,AACD,wDAAyD,kGAAwG,WAAW,CAC3K,AACD,iHAAmH,WAAW,iBAAiB,CAC9I,AACD,wDAAyD,gBAAgB,kBAAkB,WAAW,SAAS,kBAAkB,SAAS,UAAU,CACnJ,AACD,yDAA0D,gBAAgB,kBAAkB,YAAY,SAAS,iBAAiB,SAAS,UAAU,CACpJ,AACD,+CAA+C,mBAAmB,YAAY,UAAU,kBAAkB,UAAU,SAAS,CAC5H,AACD,2GAA6G,mBAAmB,WAAW,YAAY,OAAO,kBAAkB,SAAS,CACxL,AACD,qDAAsD,QAAQ,CAC7D,AACD,sDAAuD,SAAS,CAC/D,AACD,gDAAgD,mBAAmB,aAAa,WAAW,kBAAkB,UAAU,SAAS,CAC/H,AACD,2CAA2C,aAAa,mBAAmB,sBAAsB,YAAY,kBAAkB,eAAe,CAC7I,AACD,8CAA8C,gBAAgB,CAC7D,AACD,6DAA6D,oBAAoB,oBAAoB,aAAa,8BAA8B,6BAA6B,uBAAuB,mBAAmB,uBAAuB,oBAAoB,iBAAiB,mBAAmB,cAAc,CACnT,AACD,oFAAoF,YAAY,aAAa,iBAAiB,CAC7H,AACD,6CAA6C,mBAAmB,WAAW,WAAW,kBAAkB,kBAAkB,YAAY,YAAY,iBAAiB,2BAA2B,CAC7L","file":"OccupationQuestionnairePreview.vue","sourcesContent":["/*! Devices.css v0.1.16 | MIT License | github.com/picturepan2/devices.css */\n.device[data-v-a67bb9b0],.device[data-v-a67bb9b0]::before,.device[data-v-a67bb9b0]::after,.device *[data-v-a67bb9b0],.device *[data-v-a67bb9b0]::before,.device *[data-v-a67bb9b0]::after{-webkit-box-sizing:border-box;box-sizing:border-box;display:block\n}\n.device[data-v-a67bb9b0]{position:relative;-webkit-transform:scale(1);transform:scale(1);z-index:1\n}\n.device .device-frame[data-v-a67bb9b0]{z-index:1\n}\n.device .device-content[data-v-a67bb9b0]{background-color:#fff;background-position:center center;background-size:cover;-o-object-fit:cover;object-fit:cover;position:relative\n}\n.device-iphone-x[data-v-a67bb9b0]{height:868px;width:428px\n}\n.device-iphone-x .device-frame[data-v-a67bb9b0]{background:#222;border-radius:68px;-webkit-box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;height:868px;padding:28px;width:428px\n}\n.device-iphone-x .device-content[data-v-a67bb9b0]{border-radius:40px;height:812px;width:375px\n}\n.device-iphone-x .device-stripe[data-v-a67bb9b0]::after,.device-iphone-x .device-stripe[data-v-a67bb9b0]::before{border:solid rgba(51,51,51,0.25);border-width:0 7px;content:\"\";height:7px;left:0;position:absolute;width:100%;z-index:9\n}\n.device-iphone-x .device-stripe[data-v-a67bb9b0]::after{top:85px\n}\n.device-iphone-x .device-stripe[data-v-a67bb9b0]::before{bottom:85px\n}\n.device-iphone-x .device-header[data-v-a67bb9b0]{background:#222;border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:30px;left:50%;margin-left:-102px;position:absolute;top:28px;width:204px\n}\n.device-iphone-x .device-header[data-v-a67bb9b0]::after,.device-iphone-x .device-header[data-v-a67bb9b0]::before{content:\"\";height:10px;position:absolute;top:0;width:10px\n}\n.device-iphone-x .device-header[data-v-a67bb9b0]::after{background:radial-gradient(circle at bottom left, transparent 0, transparent 75%, #222 75%, #222 100%);left:-10px\n}\n.device-iphone-x .device-header[data-v-a67bb9b0]::before{background:radial-gradient(circle at bottom right, transparent 0, transparent 75%, #222 75%, #222 100%);right:-10px\n}\n.device-iphone-x .device-sensors[data-v-a67bb9b0]::after,.device-iphone-x .device-sensors[data-v-a67bb9b0]::before{content:\"\";position:absolute\n}\n.device-iphone-x .device-sensors[data-v-a67bb9b0]::after{background:#444;border-radius:3px;height:6px;left:50%;margin-left:-25px;top:32px;width:50px\n}\n.device-iphone-x .device-sensors[data-v-a67bb9b0]::before{background:#444;border-radius:50%;height:14px;left:50%;margin-left:40px;top:28px;width:14px\n}\n.device-iphone-x .device-btns[data-v-a67bb9b0]{background:#c8cacb;height:32px;left:-3px;position:absolute;top:115px;width:3px\n}\n.device-iphone-x .device-btns[data-v-a67bb9b0]::after,.device-iphone-x .device-btns[data-v-a67bb9b0]::before{background:#c8cacb;content:\"\";height:62px;left:0;position:absolute;width:3px\n}\n.device-iphone-x .device-btns[data-v-a67bb9b0]::after{top:60px\n}\n.device-iphone-x .device-btns[data-v-a67bb9b0]::before{top:140px\n}\n.device-iphone-x .device-power[data-v-a67bb9b0]{background:#c8cacb;height:100px;right:-3px;position:absolute;top:200px;width:3px\n}\n.device .mobile-container[data-v-a67bb9b0]{padding:20px;border-radius:40px;background-color:#FFF;height:100%;cursor:all-scroll;overflow:scroll\n}\n.device .mobile-container h1[data-v-a67bb9b0]{margin-top:100px\n}\n.device .mobile-container .occupations-list[data-v-a67bb9b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:left;-ms-flex-align:left;align-items:left;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.device .mobile-container .occupations-list .occupations-list-item[data-v-a67bb9b0]{width:100px;padding:10px;text-align:center\n}\n.device .occupations-submit[data-v-a67bb9b0]{background:#d4a146;color:#FFF;width:100%;text-align:center;position:relative;bottom:35px;height:35px;line-height:35px;border-radius:0 0 40px 40px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4585:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("61682276", content, true, {});

/***/ }),

/***/ 4586:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OccupationQuestionnairePreview.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":_vm.tablePath}},[_vm._v("自选职业推送列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('div',{staticClass:"device device-iphone-x"},[_c('div',{staticClass:"device-frame"},[_c('div',{staticClass:"mobile-container"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","flex-direction":"column"}},[_c('h1',[_vm._v(_vm._s(_vm.detail.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detail.detail))])]),_vm._v(" "),_c('div',{staticClass:"occupations-list"},_vm._l((_vm.detail.occupations),function(occupation){return _c('div',{staticClass:"occupations-list-item"},[_c('img',{attrs:{"src":occupation.image_url,"alt":"","width":"90","heigth":"90"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(occupation.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"occupations-submit"},[_vm._v("我选好了")])]),_vm._v(" "),_c('div',{staticClass:"device-stripe"}),_vm._v(" "),_c('div',{staticClass:"device-header"}),_vm._v(" "),_c('div',{staticClass:"device-sensors"}),_vm._v(" "),_c('div',{staticClass:"device-btns"}),_vm._v(" "),_c('div',{staticClass:"device-power"})])],2),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.tablePath}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/occupation-questionnaire-preview.f60cc7570aa9be0d0ae9.js